// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"5802e72c","453":"418fb53d","501":"603986aa","675":"74ae850d"}[chunkId] + ".chunk.js";
};